import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n, t } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={`inline-flex items-center gap-1.5 rounded-md text-xs font-medium transition-colors outline-none focus-visible:ring-1 focus-visible:ring-[#FFD700] ${
          variant === "ghost"
            ? "text-zinc-400 hover:text-[#FFD700] px-2 py-1.5"
            : "border border-zinc-800 bg-zinc-900/60 hover:border-[#FFD700]/40 hover:text-[#FFD700] text-zinc-300 px-2.5 py-1.5"
        }`}
        aria-label={t("common.language")}
        data-testid="language-switcher-trigger"
      >
        <Globe className="w-3.5 h-3.5" />
        <span className="uppercase tracking-wider">{current.code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-zinc-900 border-zinc-800 text-zinc-100 min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => i18n.changeLanguage(l.code)}
            className={`cursor-pointer ${i18n.language === l.code ? "text-[#FFD700]" : ""}`}
            data-testid={`language-option-${l.code}`}
          >
            <span className="mr-2">{l.flag}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
